<ion-row class="bank-detail-row">
  <ion-col size="2.5" data-cy="bank-detail-row-customer-information">
    <div>
      <p data-cy="bank-detail-row-customer-name">
        {{ bankDetail.customerName | titlecase }}
      </p>
      <p data-cy="bank-detail-row-customer-number">
        #{{ bankDetail.customerNumber }}
      </p>
    </div>
  </ion-col>

  <ion-col size="1.7" data-cy="bank-detail-row-nick-name">
    <p>{{ bankDetail.nickName ? bankDetail.nickName : '-' }}</p>
  </ion-col>

  <ion-col size="1.7" data-cy="bank-detail-row-bank-name">
    <p>{{ bankDetail.bankName }}</p>
  </ion-col>

  <ion-col
    size="1.7"
    data-cy="bank-detail-row-account-number
    "
    data-private
  >
    *****{{ bankDetail.last4AccountNumber }}
  </ion-col>

  <ion-col size="1.7" data-cy="bank-detail-row-routing-number" data-private>
    *****{{ bankDetail.routingNumber | slice: -4 }}
  </ion-col>

  <ion-col
    size="1.4"
    [attr.data-cy]="'bank-detail-row-' + (isAutopay ? 'start-date' : 'type')"
  >
    {{
      isAutopay
        ? bankDetail.autoDeductStartDateFormatted
        : bankDetail.isPrimary
          ? ('i18n.payments.paymentPreferences.primary' | translate)
          : '-'
    }}
  </ion-col>
  <ion-col size="1">
    <div class="buttons-column">
      <ion-icon
        class="ellipsis-menu"
        color="success"
        name="ellipsis-vertical"
        data-cy="bank-detail-row-options"
        (click)="openMoreOptions($event)"
      >
      </ion-icon>
    </div>
  </ion-col>
</ion-row>
